import { FormikProps, useFormikContext } from 'formik'
import { useStyles } from '../Plan.styles'
import {
  RadioButtonGroupMapping,
  RadioButtonsV2,
  RadioButtonType,
} from '@labrav/react-components'
import {
  AzureOfferPlan,
  Installments,
  ScheduleType,
} from '../../../../../modules/privateOffer/reducer'
import { cloneDeep } from 'lodash'
import { MsftCombinedFormState } from '../../../../../modules/microsoftCombinedForm/reducer'
import { getInstallmentsBasedOnSchedule } from '../../../../../utils/getMicrosoftInstallmentsBasedOnSchedule'
import { getPaymentOptionDisplayValue } from '../../../../MicrosoftViewPricing/getPaymentOptionDisplayValue'

export const PaymentType = ({
  plan,
  index,
  durationInMonths,
  selectedPaymentOptionValue,
}: {
  plan: AzureOfferPlan
  index: number
  durationInMonths: number
  selectedPaymentOptionValue: string
}) => {
  const { classes } = useStyles()
  const { values, setFieldValue } =
    useFormikContext() as FormikProps<MsftCombinedFormState>

  const billingTerm = plan?.pricing.recurrentPrice?.prices[0]?.billingTerm
  const paymentOption = plan?.pricing?.recurrentPrice?.prices[0]?.paymentOption

  const paymentOptionValue = getPaymentOptionDisplayValue(
    billingTerm,
    paymentOption
  )
  const paymentTypeMapping: RadioButtonGroupMapping[] = [
    {
      key: paymentOptionValue || '',
      label: paymentOptionValue || '',
      type: RadioButtonType.STANDARD,
    },
    {
      key: 'flexiblePayment',
      label: 'Flexible schedule',
      type: RadioButtonType.STANDARD,
      disabled: durationInMonths === 1,
      disabledTooltip:
        durationInMonths === 1
          ? 'This option is not available for selected plan'
          : '',
    },
  ]

  const handleChangePaymentType = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event?.target?.value

    if (value) {
      const selectedPricingPrices = plan?.pricing?.recurrentPrice?.prices
      const originalPricingPrices =
        plan?.originalPricing?.recurrentPrice?.prices?.filter(
          item =>
            item?.billingTerm?.type ===
              selectedPricingPrices[0].billingTerm.type &&
            item?.billingTerm?.value ===
              selectedPricingPrices[0].billingTerm.value
        ) || []

      const currentPrice = selectedPricingPrices[0]
      const currentTcv = currentPrice?.installments?.tcv
      const currentPricePerPayment = currentPrice?.pricePerPaymentInUsd

      const updatePlanRow = {
        ...plan,
        pricing: {
          ...plan.pricing,
          recurrentPrice: {
            ...plan.pricing.recurrentPrice,
            prices: [
              {
                ...plan.pricing.recurrentPrice?.prices[0],
                ...(value === paymentOptionValue
                  ? {
                      installments: undefined,
                      pricePerPaymentInUsd:
                        currentTcv ||
                        originalPricingPrices[0]?.pricePerPaymentInUsd ||
                        0,
                    }
                  : {}),
                ...(value === 'flexiblePayment'
                  ? {
                      installments: {
                        frequency: ScheduleType.MONTHLY,
                        tcv:
                          currentPricePerPayment ||
                          originalPricingPrices[0]?.pricePerPaymentInUsd ||
                          0,
                        schedule: getInstallmentsBasedOnSchedule({
                          tcv:
                            currentPricePerPayment ||
                            originalPricingPrices[0]?.pricePerPaymentInUsd ||
                            0,
                          durationInMonths: durationInMonths || 0,
                          paymentSchedule: ScheduleType.MONTHLY,
                          now:
                            (values?.draftOffer?.offerStartDate as string) ||
                            '',
                        }) as unknown as Installments[],
                      },
                      pricePerPaymentInUsd: undefined,
                    }
                  : {}),
              },
            ],
          },
        },
      }
      const plans = [...(values.draftOffer.plans as AzureOfferPlan[])]
      plans[index] = {
        ...cloneDeep(updatePlanRow),
      }
      setFieldValue('draftOffer.plans', [...cloneDeep(plans)])
    } else {
      setFieldValue('draftOffer.plans', [
        ...cloneDeep(values.draftOffer.plans as AzureOfferPlan[]),
      ])
    }
  }

  return (
    <>
      <div className={classes.widthRadio}>
        <RadioButtonsV2
          checkedValue={{
            key: selectedPaymentOptionValue,
            value: selectedPaymentOptionValue,
          }}
          handleChange={handleChangePaymentType}
          radioButtonMappings={paymentTypeMapping}
        />
      </div>
    </>
  )
}
